import React from "react";
import { components } from 'react-select';
import _ from "lodash";
import "components/Companies/Company/AddSingleSite/AddSingleSite.scss";


// Custom Select Component and Options -----
  export const CustomOption = (props) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div className='d-flex align-items-center pl-1 pr-1'>
          <span>{data.label}</span>
          {data.associated_icon && <span className='ml-3'>{data.associated_icon}</span>}
        </div>
      </components.Option>
    );
  };
  // -----------